import { Routes, Route, Navigate } from "react-router-dom";
import AlqemiDashboardProvider from "./context/AlqemiDashboardProvider";
import AlqemiDashboard from "./Dashboard/AlqemiDashboard";
import AlqemiWrapper from "./AlqemiWrapper";

export default function AlqemiRoutes() {
  const basePath = "/alqemi";
  
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AlqemiDashboardProvider>
            <AlqemiDashboard basePath={basePath} />
          </AlqemiDashboardProvider>
        }
      />
      <Route
        path="/dashboard"
        element={
          <AlqemiDashboardProvider>
            <AlqemiDashboard basePath={basePath} />
          </AlqemiDashboardProvider>
        }
      />
      <Route path="/:offerId/*" element={<AlqemiWrapper />} />
      <Route path="*" element={<Navigate to="/alqemi" replace />} />
    </Routes>
  );
}